import { Delete, Dots, Modify } from "assets/icons";
import Badge from "components/badge/badge";
import Button from "components/button";
import Divider from "components/divider/divider";
import useModal from "components/modal/useModal";
import { sBadge, tBadge } from "helper/helper";
import UseContext from "hooks/useContext";
import { useEffect, useRef, useState } from "react";

const CardJustify = ({ item, type }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { toggle } = useModal();
  const { setObjID, setObjType } = UseContext();

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDots = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setObjID(item._id);
    setObjType(type);
    toggle("j_d_delete");
  };

  const handleModify = (e) => {
    e.preventDefault();
    setObjID(item._id);
    if (type === "training") {
      toggle("j_u_formation");
    } else if (type === "licence") {
      toggle("j_u_licence");
    }
  };

  return (
    <>
      <div className="grid grid-cols-2">
        <div className="col-span-1 flex flex-col gap-3">
          <div>
            {item.licence ? <div>{item.licence}</div> : null}
            {item.certificate ? <div>{item.certificate}</div> : null}
            {item.name ? <div>{item.name}</div> : null}
            {item.description && (
              <div className={"ft-sm text-gray-700"}>{item.description}</div>
            )}
          </div>
          {item.validation ? (
            <div className="w-32">
              <Badge type={sBadge(item.validation)}>
                {tBadge(item.validation)}
              </Badge>
            </div>
          ) : null}
        </div>
        <div
          ref={dropdownRef}
          className="relative col-span-1 flex flex-row items-center justify-end gap-4"
        >
          <Button size={"SMI"} color={"DEFAULT"} onClick={handleDots}>
            <Dots w={14} h={4} color={"#374151"} />
          </Button>
          <div
            className={`${
              dropdownOpen ? "" : "hidden"
            }  absolute border-2 border-[#F3F4F6] rounded-lg shadow-lg w-48 px-4 py-2 top-10 right-4 z-30 bg-gray-50 flex flex-col gap-2`}
          >
            <div
              className="flex flex-row items-center gap-3 cursor-pointer ft-sm"
              onClick={handleModify}
            >
              <Modify wh={14} color={"#111827"} /> Modifier
            </div>
            <div
              className="flex flex-row items-center gap-3 cursor-pointer ft-sm text-red-600"
              onClick={handleDelete}
            >
              <Delete color={"#DC2626"} wh={15} /> Supprimer
            </div>
          </div>
        </div>
      </div>
      <div className={"my-5"}>
        <Divider w={100} />
      </div>
    </>
  );
};

export default CardJustify;
